import React from 'react';
import assets from '../data/config/config.json';
import assetsM from '../data/config/config_m.json';
const imgGeneral = assetsM.img.general;
const enlaceCurricular = assets.img.apoyosPlan;
const img = assets.img.apoyosPlan;
const img2 = assets.img.general;

const PlaneamientoMovil = (props) => {
    return ( 
        <React.Fragment>

            {/* <span>origen {props.origen}  </span> */}

            <img className="titulos img-fluid" src={img + "titulo.png" } alt="Documentos educativos oficiales" /> 
        
         <div className="row">
            <div  className="col-12 text-center contenedor2">
            <img 
                        alt="Enlace" 
                        tabIndex="3"  
                         
                        className="img-fluid"  
                        src={enlaceCurricular + "imagenEnlace.jpg"  }  
                        />
                {/* <p> La documentación vigente para el curso lectivo 2023, está disponible en el siguiente enlace:</p> */}
                <div id="enlaceCurricularMovil" class="centradoMovil"><a href="https://ddc.mep.go.cr/documentos" target="_blank">Dirección de Desarrollo Curricular ⇒</a></div>
                
            </div>
        </div>
     

        <div className="row text-center">
                <div className="col-12 contenedor2">
                    <img data-tar="Home" onClick={props.changePage} className="img-fluid hvr-pop" src={img2 + "btn_salir.png"} alt="Salir" />
                </div>
            </div>

        </React.Fragment>
     );
}

export default PlaneamientoMovil;